import BaseApiClient from "./base-client";
import { useContext } from "@/store/context";
// API Class
class TranslationsApi extends BaseApiClient {
    STUDIES_BASE_PATH = "/api/studies";
    getTranslatedValue = async (data) => {
        return this.post(`${this.STUDIES_BASE_PATH}/${useContext().currentStudyId}/translation`, { data });
    };
    static instance = new TranslationsApi();
}
export default TranslationsApi.instance;
